var map = {
  "./americanExpress.svg": "71561",
  "./applePay.svg": "78195",
  "./blik.svg": "80230",
  "./dana.svg": "62547",
  "./gcash.svg": "43300",
  "./googlePay.svg": "93803",
  "./ideal.svg": "28841",
  "./mc.svg": "83002",
  "./me.svg": "5260",
  "./mp.svg": "37381",
  "./ox.svg": "90529",
  "./paypal.svg": "25804",
  "./pix.svg": "33204",
  "./sepa_direct_debit.svg": "34334",
  "./visa.svg": "33852"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25582;
